import { useMutation } from "@tanstack/react-query"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

type GetUploadUrlData = {
  url: string
  file: File
}

type GetUploadUrlResponse = {
  accountId: string
  id: string
  partition: string
  externalId: string
  metadata: string
  name: string
  description: string
  created: string
  lastModified: string
  lastIndexed: string
  userName: string
  isOwned: boolean
  isBase: boolean
  hasSourceVideoFile: boolean
  isSearchable: boolean
  processingProgress: string
  durationInSeconds: number
  thumbnailVideoId: string
  thumbnailId: string
  indexingPreset: string
  streamingPreset: string
  personModelId: string
  animationModelId: string
  logoGroupId: string
}

function uploadVideo(data: GetUploadUrlData): Promise<GetUploadUrlResponse> {
  const formData = new FormData()
  formData.append("file", data.file)

  return api.post(data.url, formData, {
    skipAuth: true,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

export function useUploadVideo() {
  const uploadVideoMutation = useMutation({
    mutationKey: queryKeys.uploadVideo,
    mutationFn: uploadVideo,
  })

  return { uploadVideoMutation }
}
